import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  saveAll() { 
    const forms = document.querySelectorAll('form');
    if (forms.length === 0) return;

    const emailTextsData = [];
    
    forms.forEach(form => {
      const isEditForm = form.action.includes('/email_texts') && form.querySelector('input[name="_method"]');
      const isNewForm = form.action.includes('/email_texts') && form.method.toLowerCase() === 'post' && !form.querySelector('input[name="_method"]');
      
      if (isEditForm) {
        const formData = new FormData(form);
        const emailTextId = form.action.match(/\/email_texts\/(\d+)/)?.[1];
        
        if (emailTextId) {
          emailTextsData.push({
            id: emailTextId,
            content: formData.get('email_text[content]'),
            emails: formData.getAll('email_text[emails][]')
          });
        }
      } else if (isNewForm) {
        const formData = new FormData(form);
        const content = formData.get('email_text[content]');
        const emails = formData.getAll('email_text[emails][]');

        if (content && content.trim() || emails.length > 0) {
          emailTextsData.push({
            content: content,
            emails: emails
          });
        }
      }
    });

    if (emailTextsData.length > 0) {
      const lenderId = window.location.pathname.match(/\/lenders\/(\d+)/)?.[1];
      const updateUrl = `/lenders/${lenderId}/email_texts/update_all`;
      
      if (lenderId) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = updateUrl;
        form.setAttribute('data-turbo', 'true');

        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = 'authenticity_token';
        csrfInput.value = csrfToken;
        form.appendChild(csrfInput);

        const methodInput = document.createElement('input');
        methodInput.type = 'hidden';
        methodInput.name = '_method';
        methodInput.value = 'PATCH';
        form.appendChild(methodInput);

        emailTextsData.forEach((emailText, index) => {
          ['id', 'content'].forEach(field => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `email_texts[${index}][${field}]`;
            input.value = emailText[field] || '';
            form.appendChild(input);
          });
          (emailText.emails || []).forEach(email => {
            if (email) {
              const emailInput = document.createElement('input');
              emailInput.type = 'hidden';
              emailInput.name = `email_texts[${index}][emails][]`;
              emailInput.value = email;
              form.appendChild(emailInput);
            }
          });
        });
        
        document.body.appendChild(form);
        Turbo.navigator.submitForm(form);
      }
    }
  }
}
